import { useState } from "react";
import { toast } from "sonner";
import { useApi } from "./useApi";

export function useMuscleSchoolEnroll() {
  const api = useApi();
  const [checkingOut, setCheckingOut] = useState(false);

  const enroll = async () => {
    setCheckingOut(true);
    try {
      const res = await api.post("/school/enroll/checkout", { origin_url: window.location.origin });
      window.location.href = res.data.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Could not start checkout.");
    } finally {
      setCheckingOut(false);
    }
  };

  return { enroll, checkingOut, guestCheckoutEnabled: true };
}
